import React, { useContext, useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { AuthContext, base_url } from "../../../context/Authcontext";
import { Link } from "react-router-dom";
import ToastMessage from "../../ToastMessage";
import { AdminNotificationContext } from "../../../context/AdminNotificationContext";

const BrowseRecharge = () => {
  const { PaymentStatusMap } = useContext(AuthContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const { totalRecharge, setTotalRecharge } = useContext(AdminNotificationContext);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  const handleSuccessRech = async (id) => {
    try {
      const auth = localStorage.getItem("admin");
      const res = await axios.post(
        `${base_url}/api/webapi/admin/recharge/status`,
        { id, status: PaymentStatusMap.SUCCESS },
        {
          headers: { Accept: "application/json", Authorization: `${auth}` },
        }
      );
      if (res.data.status) {
        ToastMessage(1, res.data.message);
        setTotalRecharge(totalRecharge.filter((item) => item.id !== id));
      } else {
        ToastMessage(0, res.data.message);
      }
    } catch {
      ToastMessage(0, "error");
    }
  };

  const handleCancelRecharge = async (id) => {
    try {
      const auth = localStorage.getItem("admin");
      const res = await axios.post(
        `${base_url}/api/webapi/admin/recharge/status`,
        { id, status: PaymentStatusMap.CANCELLED },
        {
          headers: { Accept: "application/json", Authorization: `${auth}` },
        }
      );
      if (res.data.status) {
        ToastMessage(1, res.data.message);
        setTotalRecharge(totalRecharge.filter((item) => item.id !== id));
      } else {
        ToastMessage(0, res.data.message);
      }
    } catch {
      ToastMessage(0, "error");
    }
  };

  useEffect(() => {
    const fetchRechargeRecord = async () => {
      try {
        const auth = localStorage.getItem("admin");
        const res = await axios.get(`${base_url}/api/webapi/admin/recharge/pending`, {
          headers: { Accept: "application/json", Authorization: `${auth}` },
        });
        setTotalRecharge(res.data.list);
      } catch {
        ToastMessage(0, "error");
      }
    };
    fetchRechargeRecord();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="wrapper">
      <AdminSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} isMobile={isMobile} />
      <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} isMobile={isMobile} />

      <div
        className={`content-wrapper d-flex flex-column ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{ marginLeft: !isMobile && isSidebarOpen ? "" : "0", transition: "margin-left 0.3s ease" }}
      >
        <section className="content-header">
          <div className="container-fluid">
            <h2 className="fw-bold text-primary">💳 Pending Recharges</h2>
          </div>
        </section>

        <section className="content">
          <div className="card shadow-lg border-0 rounded">
            <div className="card-header bg-gradient-lightblue text-white d-flex justify-content-between align-items-center">
              <h3 className="card-title mb-0">
                <i className="fa fa-clock me-2"></i> Pending Recharge Requests
              </h3>
            </div>

            <div className="card-body p-0 table-responsive w-100">
              <table className="w-100 table-hover align-middle mb-0">
                <thead className="bg-light text-dark">
                  <tr>
                    <th className="px-3 text-nowrap">#</th>
                    <th className="px-3 text-nowrap">Account</th>
                    <th className="px-3 text-nowrap">Amount</th>
                    <th className="px-3 text-nowrap">Code</th>
                    <th className="px-3 text-nowrap">UTR</th>
                    <th className="px-3 text-nowrap">Proof</th>
                    <th className="px-3 text-nowrap">Method</th>
                    <th className="px-3 text-nowrap">Time</th>
                    <th className="px-3 text-nowrap">Status</th>
                    <th className="px-3 text-nowrap">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {totalRecharge?.map((e, i) => (
                    <tr key={i} className="align-middle px-3 text-nowrap text-dark border border-dark">
                      <td className="px-3 text-nowrap"><span className="badge bg-secondary">{e.id}</span></td>
                      <td className="px-3 text-nowrap"><b>{e.phone}</b></td>
                      <td className="px-3 text-nowrap"><span className="text-success fw-bold">₹{e.money}</span></td>
                      <td className="px-3 text-nowrap"><code>{e.id_order}</code></td>
                      <td className="px-3 text-nowrap"><code>{e.utr}</code></td>
                      <td className="px-3 text-nowrap">
                        {e.url ? (
                          <>
                            <img
                              src={`${base_url}${e.url}`}
                              alt="Proof"
                              className="rounded shadow-sm"
                              style={{ width: "60px", height: "60px", cursor: "pointer", objectFit: "cover" }}
                              onClick={() => openImageModal(`${base_url}${e.url}`)}
                            />
                            <div>
                              <small
                                className="text-primary"
                                style={{ cursor: "pointer" }}
                                onClick={() => openImageModal(`${base_url}${e.url}`)}
                              >
                                View Full
                              </small>
                            </div>
                          </>
                        ) : (
                          <span className="text-muted">No proof</span>
                        )}
                      </td>
                      <td className="px-3 text-nowrap"><span className="badge bg-info">{e.type}</span></td>
                      <td className="px-3 text-nowrap">
                        {(e.today.replace("T", " ")).slice(0,19)}
                      </td>

                      <td className="px-3 text-nowrap"><span className="badge bg-warning text-dark">⏳ Waiting</span></td>
                      <td className="d-flex gap-2 justify-content-center align-items-center px-3 py-4 text-nowrap">
                        <button className="btn btn-success btn-sm rounded-pill" onClick={() => handleSuccessRech(e.id)}>
                          <i className="fa fa-check"></i> Accept
                        </button>
                        <button className="btn btn-danger btn-sm rounded-pill" onClick={() => handleCancelRecharge(e.id)}>
                          <i className="fa fa-times"></i> Reject
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>

      {showImageModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.7)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded">
              <div className="modal-header bg-dark text-white">
                <h5 className="modal-title">Payment Proof</h5>
                <button type="button" className="btn-close btn-close-white" onClick={closeImageModal}></button>
              </div>
              <div className="modal-body text-center bg-light">
                <img src={selectedImage} alt="Proof" className="img-fluid rounded shadow" />
              </div>
              <div className="modal-footer bg-light">
                <button type="button" className="btn btn-secondary rounded-pill px-4" onClick={closeImageModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BrowseRecharge;
